// extracted by mini-css-extract-plugin
export default {"viewport":"BroadcastCanvas_viewport__2uM5k","canvas":"BroadcastCanvas_canvas__RlER-"};